import script from "./SubmissionEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubmissionEditor.vue?vue&type=script&setup=true&lang=ts"

import "./SubmissionEditor.vue?vue&type=style&index=0&id=7985f6d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7985f6d3"]])

export default __exports__